module.exports = __webpack_public_path__ + "img/VotoPropuesta2.34174bd1.png";